import {ResourceWizardComponent} from '@catcore/components/resource-wizard/resource-wizard.component';
import {ResourceComponent} from '@catcore/components/resource/resource.component';

export const genericResourceRoutes = [
  // {
  //   path: 'resource-map',
  //   component: ResourceMapComponent,
  // },
  {
    path: 'resource-wizard',
    component: ResourceWizardComponent,
  },
  {
    path: 'resource',
    component: ResourceComponent,
  },
];



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/core/shared/routes.ts